import { NextSeo } from 'next-seo';
import React, { useEffect } from 'react';
import SignInPage from '../components/tailwind/sign-in/sign-in-page.component';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';
import { APP_URL } from '../constants/app.constants';

const SignIn = () => {
  const router = useRouter()
  const { user } = useSelector((state:any) => state.user)

  // useEffect(() => {
  //   if (user?._id) {
  //     router.push('/contractor/home')
  //   }
  // }, [user])

  return (
  <>
    <NextSeo
      title="Sign In"
      canonical={`${APP_URL}/sign-in`}
      openGraph={{
        url: `${APP_URL}/sign-in`,
      }}
    />
    <SignInPage />
  </>
  )
};

export default SignIn;
